const layout = {
  sideBar: {
    menu: {
      more: {
        children: {
          shifts: 'Horas de trabajo',
        },
      },
    },
  },
};

export default layout;
